import { LoginModal } from './LoginModal'

export function AuthGate() {
    return <LoginModal />
}
